<template>
    <div>
    <h2> Drake's Lair:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg','Drakes Lair')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/253918470/yi6OucMQ6JVYZVdvIvleGw/original.jpg?16360676245" target="_blank">Map</a><br/>
    <v-row>
        <v-col>
            <img id="Drakes Lair" :src="require('../../../assets/Annotated_Drakes_Lair_Map.png')"  contain width="900px"/>
        </v-col>
        <v-col>
            <h2>Map Details: </h2>
            <ul>
                <li>The walls here are considered worked stone.</li>
                <li>Entire area is dimly lit and smokey, players can only see 40 feet around them.</li>
                <li>Roof is 15 feet tall unless specified otherwise.</li>
                <li>Map is 35x50</li>
                <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>
                <li>Monsters: Cyan</li>
                <li>Areas of interest: Green</li>
            </ul>
            </ul>
            <br/><br/>

            <h3>1) West Ooze Fountain</h3>
            <h4>Area Details:</h4>
            <ul>
                <li>This room smells weirdly acidic, there is a large fountain of yellow ooze pouring out of the east wall, it bubbles and froths at your entrance.</li>                
                <li>Roof is 25 feet tall.</li>
            </ul>
            <h4>Monsters:</h4>
            <ul>
                <li><b>1) Magama Ooze CR 7: </b> This magma ooze sits inside the fountain hidden (dc 25 perception check) and only attacks if players take items from the fountain (treasure 3 or 4) or attack it.</li>                
            </ul>
            <h4>Treasure:</h4>
            <ul>
                <li><b>1) Feat 125</b></li>
                <li><b>2) Spell/Maneuver 25</b></li>
                <li><b>3) E+ Stats 25</b></li>
                <li><b>4) R+ Weapon Enchantment 100: </b> Players can attempt a craft or spellcraft check DC 25 to increase this to a R+ Enchanted Weapon 100</li>
            </ul>           
            <h4>Areas Of Interest</h4>
            <ul>
                <li><b>1) Fire Trap: </b> Activates magically when a player enters a square it covers and continuously fires. Covers 5ft-15ft 6d6 fire damage reflex 17 for half. DC 24 perception and 18 disable device.</li>
            </ul> 
            <br/><br/>
            <h3>2) Drake's Nest</h3>        
            <h4>Area Details:</h4>
            <ul>
                <li>A large room filled with lava, at the back is a snoozing drake.</li>
                <li>entire room is brightly lit.</li>
                <li>Roof is 50 feet tall.</li>
            </ul>
            <h4>Monsters:</h4>
            <ul>
                <li><b>1) Flame Drake CR 5: </b> Drake doesn't attack unless players step onto the bridges AoI 1 or attack it.</li>
                <li><b>2) Medium Magma CR 3: </b> Hidden inside of the lava, will only attack if players enter onto bridges AoI 1 or if monster 1 attacks.</li>
                <li><b>3) Medium Magma CR 3: </b> Attacks on sight</li>
            </ul>
            <h4>Treasure:</h4>
            <ul>
                <li><b>1) Lvl+ Damage Spell 40</b></li>
                <li><b>2) Resurrective 75</b></li>
                <li><b>3) Perk 100</b></li>
                <li><b>3) Level Up 225</b></li>
            </ul>
            <h4>Areas Of Interest</h4>
            <ul>
                <li><b>1) Ambush Point: </b> If players cross this point all monsters in area attack.</li>
                <li><b>2) Lava: </b> first tile into lava is 1 foot deep, afterwards is 5 feet deep.</li>
            </ul>
            <br/><br/>
        </v-col>
    </v-row>
    
    <h3>3) East Ooze fountain</h3>
        <h4>Area Details:</h4>
    <ul>
        <li>This room smells weirdly acidic, there is a large fountain of yellow ooze pouring out of the east wall, it bubbles and froths at your entrance.</li>        
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Magama Ooze CR 7: </b> This magma ooze sits inside the fountain hidden (dc 25 perception check) and only attacks if players take items from the fountain (treasure 1, 2 or 3) or attack it.</li>                   
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) R+ Stats 25</b></li>
        <li><b>2) R+ Armor Enchantment 100</b></li>
        <li><b>3) Metamagic Feat 125</b></li>
    </ul>
    <h4>Areas Of Interest</h4>
        <ul>
            <li><b>1) Fire Trap: </b> Activates magically when a player enters a square it covers and continuously fires. Covers 5ft-10ft 6d6 fire damage reflex 17 for half. DC 20 perception and disable device.</li>
        </ul> 
    <br/><br/>


    <h3>4) Main Ooze Pumps</h3>
        <h4>Area Details:</h4>
    <ul>
        <li>2 large pumps continuously let off a rythmic thrumming sound, and appear to be pouring some sort of strange yellow ooze out from the lava into barrels nearby.</li>    
        <li>Pump lets off light in 20 foot area.</li>    
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Very Young Magma Dragon CR 6: </b> Wont engage immediately if players enter from area 8</li>
        <li><b>2) Kobold Scalecaster CR 1/2: </b> Replace its charm person with grease spell.</li>
        <li><b>3) Magmin CR 3: </b> Its searing aura applies to allies as well.</li>
        <li><b>4) Goblin Commando CR 2: </b> Starts combat raging.</li>        
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) 2-4 Typed potions 25: </b> Requires a DC 20 craft or knowledge nature check</li>
        <li><b>2) Typed Spell/Maneuver 60</b></li>
        <li><b>3) 2-4 potions 25 </b></li>
        <li><b>4) Feat 125</b></li>
        <li><b>5) Typed Armor 50</b></li>
        <li><b>S1) Small Gold Pile: </b> Requies a DC 23 perception check to notice.</li>
    </ul>    
    <br/><br/>


    <h3>5) North East Pump Room</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>a large pumps continuously let off a rythmic thrumming sound, and appear to be pouring some sort of strange yellow ooze out from the lava into barrels nearby. From the northwest an oppressive heat enters the room.</li>
        <li>Room has normal lighting from the lava in the adjacent room.</li>        
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Goblin Firestarter CR 4: </b> Hides behind monster 2 using it as cover</li>
        <li><b>2) Kobold Blade CR 3: </b> Uses its ranged weapon to attack until players get close.</li>
        <li><b>3) Goblin Sneak CR 1: </b> hides in the corner waiting for players to move past it then attacks the weakest looking players.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Perk 125</b></li>
        <li><b>2) 4-8 Potions 25: </b> Requires a dc 20 survival check.</li>
        <li><b>3) Armor Enchantment 100: </b> Requires a dc 20 craft or spellcraft check. If they beat DC by 5 or more it becomes a R+ Armor Enchantment 100</li>
    </ul>   
    <br/><br/>    

    <h3>6) East Pump</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>a large pumps continuously let off a rythmic thrumming sound, and appear to be pouring some sort of strange yellow ooze out from the lava into barrels nearby.</li>
        <li>Pump lets off light in 20 foot area, celing is 25 feet tall</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Goblin Firestarter CR 4: </b> Attempts to throw bombs from a distance to avoid monster 3 aura</li>
        <li><b>2) Kobold Bomber CR 1: </b> Attempts to throw bombs from a distance to avoid monster 3 aura</li>
        <li><b>3) Magmin CR 3: </b> Its searing aura applies to allies as well.</li>
    </ul>       
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) 4-8 potions</b> Requies a DC 20 survival or knowledge nature</li>
        <li><b>2) R+ Weapon Enchantment 100: </b> Requires a dc 25 Craft or knowledge arcana check. </li>
        <li><b>3) Enchanted Weapon 50 </b></li>
        <li><b>S1) Small Gold Pile: </b> Requires a DC 20 perception check to notice</li>
    </ul>       
    <br/><br/>

    
    <h3>7) Storage</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This dusty hallway seems to get little use, and it quite quite compared to the other parts of the dungeon. </li>
        <li>Area has no additional lighting</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Kobold Bomber CR 1: </b> Attacks players if it hears any of the traps in area activate</li>
        <li><b>2) Hellfire Ignis CR 3: </b> Attacks players if it hears any of the traps in area activate</li>
    </ul>        
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Typed Weapon 25</b></li>
        <li><b>2) Armor 25 </b></li>
        <li><b>3) Weapon 50 </b></li>
        <li><b>S1) Small Gold Pile: </b> Requires a DC 20 perception check to notice</li>
    </ul>     
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Fire Trap: </b> Activates on a pressure plate underneath gold. Deals 4d6 fire damage Reflex save DC 14 for half. covers the whole 10x5 area, only triggers once.</li>
        <li><b>2) Well Hidden Bear Trap: </b> requires a DC 22 perception check to notice, but otherwise acts as bear trap. Is attached to floor. </li>
        <li><b>3) Obvious Bear trap: </b> DC 10 perception check to notice, but otherwise acts as bear trap. Is attached to floor.</li>
        <li><b>4) Regular Bear trap: </b> Acts as bear trap. Is attached to floor <a href="https://www.d20pfsrd.com/gamemastering/traps-hazards-and-special-terrains/traps/bear-traps-cr-1/" target="_blank"> Bear Trap</a></li>
    </ul>
    <br/><br/>


    <h3>8) Kobald Bar</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>The sounds of cheering and plates and cutlery banging can be heard from outside this bar.</li>
        <li>Area is well lit, ceiling is 20 feet tall.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Goblin Commando CR 2: </b> Starts combat raging</li>
        <li><b>2) Kobold Bomber CR 1</b> </li>
        <li><b>3) Kobold CR 1/4</b> </li>
        <li><b>4) Kobold Sniper CR 1/2</b> </li>
        
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Resurrective 125</b></li>
        <li><b>2) L Skill 50</b></li>
        <li><b>3) Stats 50 </b></li>
        <li><b>4) E+ Stats 50: </b> Requires a DC 20 survival check.</li>
        <li><b>S1) Small Gold Pile: </b> Requires a DC 20 Perception check to notice.</li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Well Hidden Bear trap: </b> Requires a perception check dc 24 to notice, otherwise acts as bear trap. Is attached to floor <a href="https://www.d20pfsrd.com/gamemastering/traps-hazards-and-special-terrains/traps/bear-traps-cr-1/" target="_blank"> Bear Trap</a></li>
    </ul>
    <br/><br/>

    
    <h3>9) Kobold Shrine</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>Lots of chanting and stomping of feet can be heard from this area. </li>        
        <li>Ceiling is 25 feet tall</li>
        <li>If kobold bar is beaten, kobolds will set up an ambush on the other side of the door.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Medium Fire Elemental CR 3</b></li>
        <li><b>2) Kobold Sniper CR 1/4</b></li>
        <li><b>3) Kobold Scalecaster CR 1/2</b> Replace charm person with grease</li>
        <li><b>4) Goblin Sneak CR 1</b></li>
        <li><b>5) Kobold CR 1/4</b></li>
        <li><b>6) Small Fire Elemental CR 1</b></li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Spell/maneuver 40</b></li>
        <li><b>2) Armor 25</b></li>
        <li><b>3) R+ weapon 25: </b></li>
        <li><b>4) Lvl+ Typed Spell 60</b></li>
        <li><b>5) Magic Perk 100</b> Requires a DC 20 knowledge religion or knowledge arcana check. If they beat dc by 5 or more increases to a R+ Magic Perk 100</li>
        <li><b>S1) Small Gold Pile: </b> Requires a DC 15 perception check, and a DC 18 disable device or spellcraft check to obtain. If player fails disable device or spellcraft check by 5 or more they must make a will save DC 15 or be cursed with -2 to d20 rolls for the rest of the floor.</li>
    </ul>
    <br/><br/>

    
    <h3>10) Weasel Den</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This area stinks of fur and animal feces, a strange squeaking can be heard coming from within.</li>
        <li>Ceiling is 25 feet tall.</li>

    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Dire Weasel CR 3</b> </li>
        <li><b>2) Kobold Monster Wrangler CR 1: </b> Is riding a giant weasel as a mount. Replace Slurk rider feat with mounted combat feat, use handle animal instead of ride.</li>
        <li><b>3) Giant Weasel CR 1</b> </li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Teamwork Feat 200</b></li>
        <li><b>2) Stats 25</b></li>
        <li><b>3) Enchanted Armor 75</b></li>
        <li><b>S1) Small Gold Pile: </b> Requires a DC 20 diplomacy check to befriend weasels, who will unbury some gold and give it to the party.</li>
    </ul>
    <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>